import { render, staticRenderFns } from "./TestZone.html?vue&type=template&id=79aa474a&scoped=true&"
import script from "./TestZone.js?vue&type=script&lang=js&"
export * from "./TestZone.js?vue&type=script&lang=js&"
import style0 from "./TestZone.scss?vue&type=style&index=0&id=79aa474a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa474a",
  null
  
)

export default component.exports